import React, { useState, useCallback, useEffect } from 'react';
import ScrollToTop from './ScrollToTop';
import { useNavigate } from 'react-router-dom';
import { jsPDF } from 'jspdf';
import { Download, Printer, Mail, CheckCircle, Loader2, Eye, Database } from 'lucide-react';
import { Alert, AlertDescription } from "./components/ui/alert";
import { useQuote } from './QuoteContext';
import { supabase } from './supabaseClient';
import { useAuth } from './AuthContext';
import 'jspdf-autotable';
import { sendQuoteEmail } from './emailService';

const LOGO_B64 = 'data:image/png;base64,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';

const pdfSafe = (str) => {
  if (!str) return '';
  return str
    .replace(/\u00e9/g, String.fromCharCode(233))
    .replace(/\u00e8/g, String.fromCharCode(232))
    .replace(/\u00ea/g, String.fromCharCode(234))
    .replace(/\u00eb/g, String.fromCharCode(235))
    .replace(/\u00e0/g, String.fromCharCode(224))
    .replace(/\u00e2/g, String.fromCharCode(226))
    .replace(/\u00e7/g, String.fromCharCode(231))
    .replace(/\u00f4/g, String.fromCharCode(244))
    .replace(/\u00f9/g, String.fromCharCode(249))
    .replace(/\u00fb/g, String.fromCharCode(251))
    .replace(/\u00ee/g, String.fromCharCode(238))
    .replace(/\u00ef/g, String.fromCharCode(239))
    .replace(/\u00c9/g, String.fromCharCode(201))
    .replace(/\u00c8/g, String.fromCharCode(200))
    .replace(/\u00c0/g, String.fromCharCode(192))
    .replace(/\u00b2/g, '2')
    .replace(/\u00b3/g, String.fromCharCode(179))
    .replace(/\u00b0/g, String.fromCharCode(176))
    .replace(/\u00b5/g, String.fromCharCode(181));
};

const stripHtml = (html) => {
  if (!html) return '';
  return html
    .replace(/<br\s*\/?>|<\/p>|<\/div>|<\/li>/gi, '\n')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&eacute;/gi, 'é').replace(/&egrave;/gi, 'è').replace(/&agrave;/gi, 'à')
    .replace(/&ccedil;/gi, 'ç').replace(/&ecirc;/gi, 'ê').replace(/&ocirc;/gi, 'ô')
    .replace(/&ucirc;/gi, 'û').replace(/&icirc;/gi, 'î').replace(/&acirc;/gi, 'â')
    .replace(/&ugrave;/gi, 'ù').replace(/&euml;/gi, 'ë').replace(/&iuml;/gi, 'ï')
    .replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
    .replace(/&nbsp;/g, ' ').replace(/&euro;/g, '€').replace(/&#39;/g, "'").replace(/&sup2;/g, '²').replace(/&sup3;/g, '³').replace(/&deg;/g, '°').replace(/&micro;/g, 'µ')
    .replace(/▪/g, '-')
    .replace(/•/g, '-')
    .replace(/²/g, '2').replace(/³/g, '3').replace(/°/g, 'deg')
    .replace(/[^\x00-\x7E\u00C0-\u024F]/g, ' ')
    .replace(/&[A-Za-z]+;/g, '')
    .replace(/ +/g, ' ').trim();
};

const fmt = (amount) => {
  const num = Math.round((amount || 0) * 100) / 100;
  const [intPart, decPart] = num.toFixed(2).split('.');
  return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + decPart;
};


// ── Lit les dimensions réelles d'une image base64 ────────────────────────────
// Fonctionne de manière synchrone via le parsing du header binaire
const getImageDimensions = (b64) => {
  try {
    // Extraire les bytes raw (sans le préfixe data:image/...;base64,)
    const raw = b64.split(',')[1];
    const bin = atob(raw);
    const isPng = bin.charCodeAt(0) === 137 && bin.charCodeAt(1) === 80; // \x89P
    if (isPng) {
      // PNG : largeur à l'offset 16, hauteur à 20 (4 bytes big-endian chacun)
      const w = (bin.charCodeAt(16) << 24) | (bin.charCodeAt(17) << 16) |
                (bin.charCodeAt(18) << 8)  |  bin.charCodeAt(19);
      const h = (bin.charCodeAt(20) << 24) | (bin.charCodeAt(21) << 16) |
                (bin.charCodeAt(22) << 8)  |  bin.charCodeAt(23);
      return { w, h };
    } else {
      // JPEG : parser les segments SOF (Start Of Frame)
      let i = 2; // skip SOI marker FF D8
      while (i < bin.length) {
        if (bin.charCodeAt(i) !== 0xFF) break;
        const marker = bin.charCodeAt(i + 1);
        const len = (bin.charCodeAt(i + 2) << 8) | bin.charCodeAt(i + 3);
        // SOF markers: C0, C1, C2 (baseline, extended, progressive)
        if (marker === 0xC0 || marker === 0xC1 || marker === 0xC2) {
          const h = (bin.charCodeAt(i + 5) << 8) | bin.charCodeAt(i + 6);
          const w = (bin.charCodeAt(i + 7) << 8) | bin.charCodeAt(i + 8);
          return { w, h };
        }
        i += 2 + len;
      }
    }
  } catch (_) {}
  return { w: 1, h: 1 }; // fallback carré
};


// Detection dimensionnement PV depuis le titre STARTER KIT
const detectDimensionnement = (items) => {
  const titreItem = (items || []).find(it => it._titre && it.description && it.description.includes('STARTER KIT'));
  if (!titreItem) return null;
  const desc = titreItem.description || '';
  const pnom = desc.match(/Pnom:\s*(\d+)Wc/);
  const hps  = desc.match(/\((\d+(?:\.\d+)?)h\)/);
  const reg  = desc.match(/R[ée]gion:\s*([^|()\n]+?)(?:\s*\(|\s*\|)/i);
  if (!pnom) return null;
  return {
    puissanceCrete: parseInt(pnom[1]),
    hps: hps ? parseFloat(hps[1]) : 6.2,
    region: reg ? reg[1].trim() : 'Dakar',
  };
};

const detectClim = (items) => {
  const t = (items || []).find(it => it._titre && it.description && it.description.includes('KIT CLIMATISATION'));
  if (!t) return null;
  const d = t.description || '';
  const btu = d.match(/(\d+)\s*BTU/);
  const cv = d.match(/\(([^)]+CV)\)/);
  const surf = d.match(/Surface:\s*(\d+(?:\.\d+)?)m2/i);
  const mode = d.match(/Mode:\s*([^\n|]+)/i);
  if (!btu) return null;
  const btuMap = { 9000: 450, 12000: 650, 18000: 900, 20000: 1000, 24000: 1200, 30000: 1500, 36000: 1800 };
  const btuVal = parseInt(btu[1]);
  return { btu: btuVal, cv: cv ? cv[1] : '', surface: surf ? parseFloat(surf[1]) : 0, mode: mode ? mode[1].trim() : '', puissanceW: btuMap[btuVal] || Math.round(btuVal / 10) };
};

const PEAK_POWER_GEN = {
  'S-400E': 1000, 'S-1200E': 3600, 'S-1800E': 4000,
  'S-2400E': 5000, 'S-3600E': 6000, 'S-5000E': 7000,
};

const detectGenerateur = (items) => {
  // Chercher le titre kit générateur
  const t = (items || []).find(it =>
    it._titre && it.description &&
    it.description.includes('KIT GENERATEUR SOLAIRE MOBILE')
  );
  if (!t) return null;
  const d = t.description || '';

  // Lire ref et peak depuis le titre
  const refMatch = d.match(/Ref: (S-[A-Z0-9]+)/);
  const ref = refMatch ? refMatch[1] : null;
  const peakMatch = d.match(/Puissance de pointe : (\d+)W/);
  const peak = peakMatch ? parseInt(peakMatch[1]) : (ref ? (PEAK_POWER_GEN[ref] || 0) : 0);

  // Lire nominal, pointe et aMoteur depuis la description de l'article générateur
  const genItem = (items || []).find(it =>
    !it._titre && it.description &&
    it.description.includes('Puissance nominale :') &&
    it.description.includes('Puissance de pointe :')
  );
  const gd = genItem ? genItem.description : '';

  const nominalMatch = gd.match(/Puissance nominale : (\d+)W/);
  const nominal = nominalMatch ? parseInt(nominalMatch[1]) : 0;

  const clientMatch = gd.match(/Puissance nominale du\/des.*?: (\d+)W/);
  const pointe = clientMatch ? parseInt(clientMatch[1]) : 0;

  const aMoteur = gd.includes('Pic de d') || gd.includes('moteur');

  return { pointe, ref, nominal, peak, aMoteur };
};


const detectFrigo = (items) => {
  const t = (items || []).find(it => it._titre && it.description && it.description.includes('KIT RÉFRIGÉRATION SOLAIRE'));
  if (!t) return null;
  const d = t.description || '';
  // Chercher l article frigo (ref FRIGO- ou CONGE-)
  const frigoItem = (items || []).find(it => !it._titre && it.description && (it.description.includes('Ref: FRIGO-') || it.description.includes('Ref: CONGE-') || it.description.includes('Ref: GLACE-')));
  if (!frigoItem) return null;
  const fd = frigoItem.description || '';
  // Extraire la puissance depuis PRODUITS_BASE via la ref
  const refMatch = fd.match(/Ref: ([A-Z0-9-]+)/);
  const ref = refMatch ? refMatch[1] : '';
  // Map ref -> puissance W (cycle 24h)
  const puissMap = {
    'FRIGO-BC-50': 50, 'FRIGO-BC-90': 65,
    'FRIGO-BCD-90D': 70, 'FRIGO-BCD-118': 75, 'FRIGO-BCD-128': 70,
    'FRIGO-BCD-142': 76, 'FRIGO-BCD-168': 100, 'FRIGO-BCD-178': 85,
    'FRIGO-BCD-198': 90, 'FRIGO-BCD-218': 91, 'FRIGO-BCD-268': 93,
    'FRIGO-BCD-270': 98, 'FRIGO-BCD-298': 99, 'FRIGO-BCD-338': 103,
    'CONGE-BC-68': 38, 'CONGE-BC-88': 43, 'CONGE-BC-108': 47,
    'CONGE-BC-158': 49, 'CONGE-BC-208': 68, 'CONGE-BC-258': 78,
    'CONGE-BC-268': 80, 'CONGE-BC-308': 95, 'CONGE-BC-358': 100,
    'CONGE-BC-508': 115, 'CONGE-BD-198': 225,
    'CONGE-BC-558': 155, 'CONGE-BC-698': 166, 'CONGE-BC-798': 189,
    'CONGE-BC-1088': 223, 'CONGE-BC-1388': 255, 'CONGE-BC-1688': 271,
    'FRIGO-SG-SC175': 90, 'FRIGO-SG-SC218': 95, 'FRIGO-SG-SC318': 100,
    'GLACE-IM-30': 165,
  };
  const puissW = puissMap[ref] || 80;
  const quantite = frigoItem.quantity || 1;
  return { ref, puissW: puissW * quantite };
};

const detectChauffe = (items) => {
  const t = (items || []).find(it => it.description && (it.description.includes('SUNNYBOILER') || it.description.includes('Chauffe-eau Solaire')));
  if (!t) return null;
  const d = t.description || '';
  const vol = d.match(/(\d+)L/);
  if (!vol) return null;
  const litres = parseInt(vol[1]);
  // Puissance resistance electrique equivalente selon volume
  const puissMap = { 50: 1000, 100: 1500, 150: 2000, 200: 2500, 250: 2500, 300: 3000, 360: 3000 };
  const puissW = puissMap[litres] || 2500;
  // Foyer selon volume
  const foyerMap = { 50: '1-2', 100: '2-3', 150: '4-5', 200: '6-8', 250: '8-10', 300: '10-12', 360: '12-14' };
  return { litres, puissW, foyer: foyerMap[litres] || '6-8' };
};

const buildPDF = (quoteData, showEur = false) => {
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  const W = 210;
  const M = 14;
  const ML = M - 3; // 11mm — aligné avec le rectangle glassmorphism
  const MR = M - 3; // 11mm — symétrique
  const BLUE = [0, 82, 155];
  const LIGHT_BLUE = [232, 241, 255];
  const ORANGE = [232, 67, 26];
  const GRAY = [130, 130, 130];
  const DARK = [40, 40, 40];
  const LINE = [200, 200, 200];

  const company = quoteData.companyInfo || {};
  const client = quoteData.clientInfo || {};
  const items = quoteData.items || [];
  const telStr = company.phone || company.tel || '(+221) 33 836 67 83';
  const mobStr = company.mob || '(+221) 78 346 88 51';
  const emailStr = company.email || 'contact@takoussane.com';

  // ── EN-TETE PREMIUM ───────────────────────────────────────────────────────
  // Header légèrement plus haut pour loger la mention validité
  const HEADER_H = 31;
  const STRIPE = 1.2;

  doc.setFillColor(...BLUE);
  doc.rect(0, 0, W, HEADER_H, 'F');

  // Bande orange fine premium tout en bas du header
  doc.setFillColor(...ORANGE);
  doc.rect(0, HEADER_H - STRIPE, W, STRIPE, 'F');

  // Rectangle semi-transparent derrière le logo — effet glassmorphism premium
  const logoW = 72;
  const logoH = 13;
  const logoX = M;
  const logoY = (HEADER_H - STRIPE - logoH) / 2; // centré verticalement
  const padX = 3;
  const padY = 2.5;

  // Fond blanc semi-transparent (simulé avec alpha via opacité jsPDF)
  doc.saveGraphicsState();
  doc.setGState(new doc.GState({ opacity: 0.15 }));
  doc.setFillColor(255, 255, 255);
  doc.roundedRect(logoX - padX, logoY - padY, logoW + padX * 2, logoH + padY * 2, 3, 3, 'F');
  doc.restoreGraphicsState();

  // Logo centré verticalement
  try {
    doc.addImage(LOGO_B64, 'PNG', logoX, logoY, logoW, logoH);
  } catch (_) {
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(15);
    doc.setFont('helvetica', 'bold');
    doc.text('TAKOUSSANE ENERGY', M, HEADER_H / 2);
  }

  // Bloc DEVIS à droite
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(24);
  doc.setFont('helvetica', 'bold');
  doc.text('DEVIS', W - M, 12, { align: 'right' });

  doc.setFontSize(8.5);
  doc.setFont('helvetica', 'normal');
  doc.text('No. ' + (quoteData.quoteNumber || 'N/A'), W - M, 18.5, { align: 'right' });
  const fmtDate = (d) => {
    if (!d) return new Date().toLocaleDateString('fr-FR');
    const parts = d.split('-');
    if (parts.length === 3) return parts[2] + '/' + parts[1] + '/' + parts[0];
    return d;
  };
  doc.text(fmtDate(quoteData.date), W - M, 23.5, { align: 'right' });

  // Mention validité + tel en orange — DANS le header bleu, AU-DESSUS de la bande
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(7);
  doc.setFont('helvetica', 'italic');
  doc.text(
    'Valable ' + (quoteData.offerValidity || 30) + ' jours  |  ' + telStr,
    W - M, HEADER_H - STRIPE - 1.5, { align: 'right' }
  );

  // ── EMETTEUR / CLIENT ─────────────────────────────────────────────────────
  let y = HEADER_H + 5;
  const colW = (W - ML - MR - 6) / 2;

  doc.setFillColor(...LIGHT_BLUE);
  doc.rect(ML, y, colW, 42, 'F');
  doc.rect(ML + colW + 6, y, colW, 42, 'F');

  doc.setFontSize(7.5);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...BLUE);
  doc.text('EMETTEUR', ML + 3, y + 6);
  doc.text('CLIENT', ML + colW + 9, y + 6);

  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...DARK);
  doc.setFontSize(8);

  const contactStr = company.contact || '';
  const emetteurLines = [
    'TAKOUSSANE ENERGY',
    company.address || 'BP 302 Rufisque Ouest, Dakar',
    'Tel: ' + telStr,
    'Mob: ' + mobStr,
    'Email: ' + emailStr,
  ];
  if (contactStr) emetteurLines.push('Contact: ' + contactStr);
  emetteurLines.forEach((l, i) => doc.text(l, ML + 3, y + 13 + i * 4));

  const clientTitle = client.attentionTitle || '';
  const clientAttn = client.attentionName || '';
  const clientName = client.clientName || client.name || company.contact || '';
  const clientFullName = clientName;
  const clientContact = clientTitle && clientAttn ? clientTitle + ' ' + clientAttn : '';
  const formatPhone = (n) => {
    if (!n) return '';
    const s = n.toString().trim();
    if (!s) return '';
    // Deja formate (espaces ou parentheses) : on garde tel quel
    if (s.includes(' ') || s.includes('(')) return s;
    const plus = s.startsWith('+');
    const d = s.replace(/\D/g, '');
    if (!d) return s;
    const groupes = (str) => str.replace(/(\d{2,3})(?=\d{2})/g, '$1 ').trim();
    // Mobile/fixe senegalais local : 9 chiffres -> XX XXX XX XX
    if (!plus && d.length === 9) {
      return d.slice(0,2) + ' ' + d.slice(2,5) + ' ' + d.slice(5,7) + ' ' + d.slice(7,9);
    }
    // Format international +221 XX XXX XX XX (12 chiffres avec indicatif)
    if (d.startsWith('221') && d.length === 12) {
      const r = d.slice(3);
      return '(+221) ' + r.slice(0,2) + ' ' + r.slice(2,5) + ' ' + r.slice(5,7) + ' ' + r.slice(7,9);
    }
    // Numero avec + : on prefixe et on groupe le reste
    if (plus) return '+' + groupes(d);
    // Fallback robuste : on retourne toujours les chiffres groupes (jamais vide)
    return groupes(d) || s;
  };
  const clientMob = formatPhone(client.mobile || client.mob || '');
  const clientPhone = formatPhone(client.phone || '');
  const clientEmail = client.email || '';
  const clientCity = client.address || '';
  const clientCountry = client.region || 'Sénégal';
  // Option B : 6 lignes fixes — "(non renseigné)" si vide
[
  clientFullName,
  clientContact ? 'Attn: ' + clientContact : 'Attn: (non renseigné)',
  'Mob: ' + (clientMob || '(non renseigné)'),
  'Tel: ' + (clientPhone || '(non renseigné)'),
  'Email: ' + (clientEmail || '(non renseigné)'),
  'Ville: ' + (clientCity || '(non renseigné)'),
].forEach((l, i) => doc.text(l, ML + colW + 9, y + 13 + i * 4));

  // ── TABLEAU ───────────────────────────────────────────────────────────────
  y += 48;
  const hasImages = items.some(it => it.image && it.image.startsWith('data:image'));
  const tableWidth = W - ML - MR;

  const head = hasImages
    ? [[{content:'N',styles:{halign:'center'}},{content:'Image',styles:{halign:'center'}},'Description',{content:'Qté',styles:{halign:'center'}},{content:'Prix Unitaire FCFA',styles:{halign:'right'}},{content:'Montant FCFA',styles:{halign:'right'}}]]
    : [[{content:'N',styles:{halign:'center'}},'Description',{content:'Qte',styles:{halign:'center'}},{content:'Prix Unitaire FCFA',styles:{halign:'right'}},{content:'Montant FCFA',styles:{halign:'right'}}]];

const body = items.length > 0
    ? items.map((item, idx) => {
        if (item._titre) {
          const cols = hasImages ? 6 : 5;
return [{
            content: pdfSafe(stripHtml(item.description)),
            colSpan: cols,
            styles: {
              fontStyle: 'bold',
              textColor: [0, 82, 155],
              fillColor: [232, 241, 255],
              fontSize: 8.5,
              halign: 'left',
              cellPadding: 3,
              minCellHeight: 0,
            }
          }];
        }
        // Recalcul index sans compter les lignes titre
        const realIdx = items.slice(0, idx).filter(i => !i._titre).length;
        const desc = pdfSafe(stripHtml(item.description)) || 'Article';
        const qty = item.quantity || 1;
        const price = item._offert ? 0 : (item.unitPrice || 0);
        const priceDisplay = item._offert ? 'Offert' : fmt(price);
        return hasImages
          ? [realIdx+1, '', desc, qty, priceDisplay, item._offert ? 'Offert' : fmt(qty*price)]
          : [realIdx+1, desc, qty, priceDisplay, item._offert ? 'Offert' : fmt(qty*price)];
      })
    : [hasImages ? [1,'','Aucun article','-','-','-'] : [1,'Aucun article','-','-','-']];

  const descW = hasImages ? tableWidth-10-28-14-38-38 : tableWidth-10-14-38-38;
  const colStyles = hasImages
    ? {0:{cellWidth:10,halign:'center'},1:{cellWidth:28,halign:'center',overflow:'hidden'},2:{cellWidth:descW},3:{cellWidth:14,halign:'center'},4:{cellWidth:38,halign:'right'},5:{cellWidth:38,halign:'right'}}
    : {0:{cellWidth:10,halign:'center'},1:{cellWidth:descW},2:{cellWidth:14,halign:'center'},3:{cellWidth:38,halign:'right'},4:{cellWidth:38,halign:'right'}};

  doc.autoTable({
    startY: y, head, body, theme: 'grid',
    margin: { left: ML, right: MR, bottom: 28 },
    rowPageBreak: 'avoid',
    headStyles: { fillColor: BLUE, textColor: [255,255,255], fontStyle: 'bold', fontSize: 8.5, cellPadding: 3 },
    bodyStyles: { fontSize: 8, cellPadding: 3, minCellHeight: hasImages ? 25 : 8, valign: 'middle', textColor: DARK },
    columnStyles: colStyles,
    alternateRowStyles: { fillColor: [248, 250, 255] },
    didDrawCell: (data) => {
      if (!hasImages || data.section !== 'body' || data.column.index !== 1) return;
      const item = items[data.row.index];
      if (item?.image && item.image.startsWith('data:image') && item.image.length > 100) {
        try {
          const ext = item.image.includes('image/png') ? 'PNG' : 'JPEG';
          // ── Dimensions réelles via parsing du header binaire ──────────────
          const { w: natW, h: natH } = getImageDimensions(item.image);
          const ratio = natW / Math.max(natH, 1);
          // Zone disponible dans la cellule (2mm de marge chaque côté)
          const maxW = data.cell.width - 4;
          const maxH = data.cell.height - 4;
          // Fit en conservant le ratio (letterbox/pillarbox)
          let drawW, drawH;
          if (ratio >= maxW / maxH) {
            drawW = maxW;
            drawH = drawW / ratio;
          } else {
            drawH = maxH;
            drawW = drawH * ratio;
          }
          // Centrer dans la cellule
          const drawX = data.cell.x + (data.cell.width - drawW) / 2;
          const drawY = data.cell.y + (data.cell.height - drawH) / 2;
          doc.addImage(item.image, ext, drawX, drawY, drawW, drawH);
        } catch(_) {}
      }
    },
  });

  // ── RECAPITULATIF ─────────────────────────────────────────────────────────
y = doc.lastAutoTable.finalY + 6;
  // Si le bloc totaux (~60mm) ne tient pas sur la page courante, nouvelle page
  const totalBlockH = 42;
  const pageH = doc.internal.pageSize.height;
  const footerReserve = 28; // espace réservé pour le footer
  if (y + totalBlockH > pageH - footerReserve) {
    doc.addPage();
    y = 20;
  }

  const rW = 84;
  const rX = W - MR - rW;
  // Calcul a la volee - synchrone et independant du state React
  const _items = quoteData.items || [];
  const _itemsTotal = _items.filter(i => !i._titre).reduce((s, i) => s + (parseFloat(i.unitPrice)||0) * (parseFloat(i.quantity)||0), 0);
  const deliveryCost = parseFloat(quoteData.deliveryCost) || 0;
  const _discountPct = parseFloat(quoteData.discountPct) || 0;
  const _discountFixed = parseFloat(quoteData.discount) || 0;
  const _baseRemise = _itemsTotal + deliveryCost;
  const discount = _discountPct > 0 ? Math.round(_baseRemise * _discountPct / 100) : _discountFixed;
  const subtotal = _itemsTotal;
  const _totalHT = _baseRemise - discount;
  const vat = quoteData.vatOption !== 'without_vat' ? Math.round(_totalHT * (parseFloat(quoteData.vatRate)||18) / 100) : 0;
  const totalNet = _totalHT + vat;

  [
    ['Sous-total en FCFA', fmt(subtotal)],
    deliveryCost > 0 ? ['Livraison', fmt(deliveryCost)] : null,
    discount > 0 ? ['Remise commerciale (' + (quoteData.discountPct || Math.round(discount / _baseRemise * 1000) / 10) + '%)', '- ' + fmt(discount)] : null,
    ['Total en FCFA', fmt(subtotal + deliveryCost - discount)],
    quoteData.vatOption !== 'without_vat' ? ['TVA (' + (quoteData.vatRate||18) + '%)', fmt(vat)] : null,
  ].filter(Boolean).forEach(([label, value]) => {
    doc.setFillColor(245, 247, 252);
    doc.rect(rX, y-4, rW, 7, 'F');
    doc.setDrawColor(...LINE);
    doc.rect(rX, y-4, rW, 7, 'S');
    doc.setFontSize(8.5);
    doc.setTextColor(...DARK);
    doc.setFont('helvetica', 'normal');
    doc.text(label, rX+3, y);
    doc.text(value, W-M-2, y, { align: 'right' });
    y += 8;
  });

  doc.setFillColor(...BLUE);
  doc.rect(rX, y-4, rW, 10, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('Montant NET en FCFA', rX+3, y+2);
  doc.text(fmt(totalNet), W-M-2, y+2, { align: 'right' });

  y += 12;
  doc.setTextColor(...GRAY);
  doc.setFontSize(7);
  doc.setFont('helvetica', 'italic');
  if (showEur) doc.text('Equivalent indicatif : ' + (totalNet/655.957).toFixed(2) + ' EUR (1 EUR = 655,957 FCFA)', rX, y);

  // ── PIED DE PAGE — ligne bleue (pas orange) ───────────────────────────────
  const w = quoteData.warranties || {};
  // SECTION ROI
  const dimData = detectDimensionnement(items);
  const climData = detectClim(items);
  const chauffeData = detectChauffe(items);
  const frigoData = detectFrigo(items);
  const hasHybrid = (items || []).some(it => it.description && (it.description.includes('SRNE-HYP') || it.description.includes('HYP 5kW') || it.description.includes('Onduleur Hybride')));

  const genData = detectGenerateur(items);
  if (dimData) {
    const tarifKwh = quoteData.tarifKwh || 200;
    const { puissanceCrete, hps, region } = dimData;
    const kWc = puissanceCrete / 1000;
    const productionAnnuelle = Math.round(kWc * hps * 365 * 0.8);
    const economiesAnnuelles = Math.round(productionAnnuelle * tarifKwh);
    const montantDevis = quoteData.totalWithVat || 0;
    const roiDecimal3 = montantDevis > 0 ? montantDevis / economiesAnnuelles : 0;
    const roiAns = roiDecimal3 > 0 ? (Math.floor(roiDecimal3) + ' an' + (Math.floor(roiDecimal3) > 1 ? 's' : '') + (Math.round((roiDecimal3 % 1) * 12) > 0 ? ' ' + Math.round((roiDecimal3 % 1) * 12) + ' mois' : '')) : '--';
    const eco10ans = economiesAnnuelles * 10;
    const eco25ans = economiesAnnuelles * 25;
    const roiBlockH = 62;
    if (y + roiBlockH > pageH - footerReserve) { doc.addPage(); y = 20; }
    y += 6;
    doc.setFillColor(...BLUE);
    doc.rect(ML, y, W - ML - MR, 7, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.text('VOTRE INVESTISSEMENT SOLAIRE EN CHIFFRES', ML + 3, y + 5);
    y += 9;
    const roiData = [
      ['Puissance install' + String.fromCharCode(233) + 'e', kWc.toFixed(2) + ' kWc  (' + puissanceCrete + ' Wc)', region + ' - ' + hps + 'h pic solaire/j'],
      ['Production annuelle estim' + String.fromCharCode(233) + 'e', fmt(productionAnnuelle) + ' kWh/an', 'Coefficient de performance : 80%'],
      [String.fromCharCode(201) + 'conomies annuelles SENELEC', fmt(economiesAnnuelles) + ' FCFA/an', 'Tarif : ' + tarifKwh + ' FCFA/kWh'],
      ['Retour sur investissement', roiAns, 'Sur la base du montant NET TTC de ce devis'],
      [String.fromCharCode(201) + 'conomies sur 10 ans', fmt(eco10ans) + ' FCFA', '120 mois de facture SENELEC ' + String.fromCharCode(233) + 'conomis' + String.fromCharCode(233) + 's'],
      [String.fromCharCode(201) + 'conomies sur 25 ans', fmt(eco25ans) + ' FCFA', 'Dur' + String.fromCharCode(233) + 'e de vie minimale du projet (30-35 ans)'],
    ];
    roiData.forEach(([label, value, note], i) => {
      const rowBg = i % 2 === 0 ? [248, 250, 255] : [255, 255, 255];
      doc.setFillColor(...rowBg);
      doc.rect(ML, y, W - ML - MR, 6.5, 'F');
      doc.setDrawColor(...LINE);
      doc.rect(ML, y, W - ML - MR, 6.5, 'S');
      doc.setTextColor(...DARK);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7.5);
      doc.text(label, ML + 3, y + 4.3);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...BLUE);
      doc.text(value, ML + 90, y + 4.3);
      doc.setTextColor(...GRAY);
      doc.setFontSize(6.5);
      if (note) doc.text(note, W - MR - 3, y + 4.3, { align: 'right' });
      y += 6.5;
    });
    y += 3;
    doc.setFillColor(232, 241, 255);
    doc.rect(ML, y, W - ML - MR, 7, 'F');
    doc.setTextColor(...BLUE);
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(7);
    doc.text('* Estimations bas' + String.fromCharCode(233) + 'es sur donn' + String.fromCharCode(233) + 'es terrain r' + String.fromCharCode(233) + 'gion ' + region + '. Les ' + String.fromCharCode(233) + 'conomies r' + String.fromCharCode(233) + 'elles peuvent varier.', ML + 3, y + 4.5);
    y += 10;
    // Note technique expert - signature dimensionnement
    if (hasHybrid) {
      if (y + 18 > pageH - footerReserve) { doc.addPage(); y = 20; }
      y += 3;
      doc.setFillColor(30, 58, 95);
      doc.rect(ML, y, 4, 14, 'F');
      doc.setFillColor(248, 250, 252);
      doc.rect(ML + 4, y, W - ML - MR - 4, 14, 'F');
      doc.setDrawColor(30, 58, 95);
      doc.setLineWidth(0.3);
      doc.rect(ML, y, W - ML - MR, 14, 'S');
      doc.setTextColor(30, 58, 95);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7.5);
      doc.text('Dimensionnement expert', ML + 8, y + 5);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(6.8);
      doc.setTextColor(51, 65, 85);
      doc.text('Puissance calculée sur charge de pointe foisonnée — Pics de démarrage moteur de climatiseur absorbés par réserve surge 2× nominale de l’onduleur hybride SRNE.', ML + 8, y + 10.5, { maxWidth: W - ML - MR - 12 });
      y += 17;
    }
  }

  if (climData && !dimData) {
    const tarifKwh = 189;
    const { btu, cv, surface, mode, puissanceW } = climData;
    const montantDevis = quoteData.totalWithVat || 0;
    const consoAnnuelle = Math.round(puissanceW * 1.2 * 12 * 365 / 1000);
    const economiesAnnuelles = Math.round(consoAnnuelle * tarifKwh);
    const roiDecimal3 = montantDevis > 0 ? montantDevis / economiesAnnuelles : 0;
    const roiAns = roiDecimal3 > 0 ? (Math.floor(roiDecimal3) + ' an' + (Math.floor(roiDecimal3) > 1 ? 's' : '') + (Math.round((roiDecimal3 % 1) * 12) > 0 ? ' ' + Math.round((roiDecimal3 % 1) * 12) + ' mois' : '')) : '--';
    const eco10ans = economiesAnnuelles * 10;
    const eco15ans = economiesAnnuelles * 15;
    if (y + 62 > pageH - footerReserve) { doc.addPage(); y = 20; }
    y += 6;
    doc.setFillColor(...BLUE);
    doc.rect(ML, y, W - ML - MR, 7, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.text('VOTRE INVESTISSEMENT CLIMATISATION SOLAIRE EN CHIFFRES', ML + 3, y + 5);
    y += 9;
    [
      ['Climatiseur ' + btu + ' BTU (' + cv + ')', 'Surface : ' + surface + ' m' + String.fromCharCode(178), 'Mode : ' + mode],
      ['Conso clim AC classique ' + String.fromCharCode(233) + 'quivalente', consoAnnuelle + ' kWh/an', 'Puissance nominale x1.2 x12h x365j'],
      [String.fromCharCode(201) + 'conomies annuelles SENELEC', fmt(economiesAnnuelles) + ' FCFA/an', 'Tarif : ' + tarifKwh + ' FCFA/kWh'],
      ['Retour sur investissement', roiAns, 'Sur la base du montant NET TTC de ce devis'],
      [String.fromCharCode(201) + 'conomies sur 10 ans', fmt(eco10ans) + ' FCFA', '120 mois de facture SENELEC ' + String.fromCharCode(233) + 'conomis' + String.fromCharCode(233) + 's'],
      [String.fromCharCode(201) + 'conomies sur 15 ans', fmt(eco15ans) + ' FCFA', 'Dur' + String.fromCharCode(233) + 'e de vie minimale (15-20 ans)'],
    ].forEach(([label, value, note], idx) => {
      doc.setFillColor(...(idx % 2 === 0 ? [248, 250, 255] : [255, 255, 255]));
      doc.rect(ML, y, W - ML - MR, 6.5, 'F');
      doc.setDrawColor(...LINE);
      doc.rect(ML, y, W - ML - MR, 6.5, 'S');
      doc.setTextColor(...DARK); doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5);
      doc.text(label, ML + 3, y + 4.3);
      doc.setFont('helvetica', 'normal'); doc.setTextColor(...BLUE);
      doc.text(value, ML + 90, y + 4.3);
      doc.setTextColor(...GRAY); doc.setFontSize(6.5);
      if (note) doc.text(note, W - MR - 3, y + 4.3, { align: 'right' });
      y += 6.5;
    });
    y += 3;
    doc.setFillColor(232, 241, 255);
    doc.rect(ML, y, W - ML - MR, 7, 'F');
    doc.setTextColor(...BLUE); doc.setFont('helvetica', 'italic'); doc.setFontSize(7);
    doc.text('* Estimations bas' + String.fromCharCode(233) + 'es sur comparaison avec clim AC classique 12h/j. Les ' + String.fromCharCode(233) + 'conomies r' + String.fromCharCode(233) + 'elles peuvent varier.', ML + 3, y + 4.5);
    y += 10;
  }
  // ROI Pompe depuis localStorage
  const roiPompeData = (() => { try { const d = localStorage.getItem('roiPompe'); return d ? JSON.parse(d) : null; } catch(_) { return null; } })();
  const hasPompe = (items || []).some(it => it._titre && it.description && it.description.includes('KIT POMPE SOLAIRE'));
  if (hasPompe && roiPompeData && !dimData && !climData && !chauffeData) {
    const { roi, totalKit, pompeRef } = roiPompeData;
    const fmtROI = (mois) => { if (!mois) return '--'; const a = Math.floor(mois/12); const m = mois%12; return a > 0 ? a + ' an' + (a>1?'s':'') + (m>0?' '+m+' mois':'') : m + ' mois'; };
    if (y + 120 > pageH - footerReserve) { doc.addPage(); y = 20; }
    y += 6;
    doc.setFillColor(...BLUE);
    doc.rect(ML, y, W - ML - MR, 7, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.text('VOTRE INVESTISSEMENT POMPE SOLAIRE EN CHIFFRES', ML + 3, y + 5);
    y += 9;
    // Ligne titre pompe
    doc.setFillColor(232, 241, 255);
    doc.rect(ML, y, W - ML - MR, 6.5, 'F');
    doc.setDrawColor(...LINE);
    doc.rect(ML, y, W - ML - MR, 6.5, 'S');
    doc.setTextColor(...BLUE); doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5);
    doc.text(pompeRef || 'Kit Pompe Solaire', ML + 3, y + 4.3);
    doc.setFont('helvetica', 'normal'); doc.setTextColor(...GRAY); doc.setFontSize(6.5);
    doc.text('Co' + String.fromCharCode(251) + 't total kit : ' + fmt(totalKit) + ' FCFA', W - MR - 3, y + 4.3, { align: 'right' });
    y += 6.5;
    // 3 scenarios
    const roiMins = [roi.seneau.roiMois, roi.gasoil.roiMois, roi.elec.roiMois];
    const scenarios = [
      { label: 'Sc' + String.fromCharCode(233) + 'nario 1 : Remplacement SEN' + String.fromCharCode(39) + 'EAU', roi: roi.seneau, unite: 'm3/mois', detail: roi.seneau.volumeMois + ' m3/mois x ' + Math.round(roi.seneau.prixM3).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' FCFA/m3' },
      { label: 'Sc' + String.fromCharCode(233) + 'nario 2 : Remplacement groupe ' + String.fromCharCode(233) + 'lectrog' + String.fromCharCode(232) + 'ne', roi: roi.gasoil, unite: 'L/mois', detail: roi.gasoil.litresMois + ' L/mois x ' + Math.round(roi.gasoil.prixLitre).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' FCFA/L' },
      { label: 'Sc' + String.fromCharCode(233) + 'nario 3 : Remplacement pompe ' + String.fromCharCode(233) + 'lectrique', roi: roi.elec, unite: 'kWh/mois', detail: roi.elec.kwhMois + ' kWh/mois x ' + roi.elec.tarifKwh + ' FCFA/kWh' },
    ];
    scenarios.forEach((sc, si) => {
      const bg = si % 2 === 0 ? [248, 250, 255] : [255, 255, 255];
      // Ligne entete scenario
      doc.setFillColor(220, 232, 255);
      doc.rect(ML, y, W - ML - MR, 5.5, 'F');
      doc.setDrawColor(...LINE);
      doc.rect(ML, y, W - ML - MR, 5.5, 'S');
      doc.setTextColor(...BLUE); doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5);
      doc.text(sc.label, ML + 3, y + 3.8);

      doc.setTextColor(...GRAY); doc.setFont('helvetica', 'normal'); doc.setFontSize(6.5);
      doc.text(sc.detail, W - MR - 3, y + 3.8, { align: 'right' });
      y += 5.5;
      // Ligne eco mensuelle + ROI
      doc.setFillColor(...bg);
      doc.rect(ML, y, W - ML - MR, 5.5, 'F');
      doc.rect(ML, y, W - ML - MR, 5.5, 'S');
      doc.setTextColor(...DARK); doc.setFont('helvetica', 'normal'); doc.setFontSize(7);
      doc.text(String.fromCharCode(201) + 'conomie mensuelle : ' + Math.round(sc.roi.ecoMois).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' FCFA/mois', ML + 3, y + 3.8);
      doc.setTextColor(...BLUE); doc.setFont('helvetica', 'bold');
      doc.text('ROI : ' + fmtROI(sc.roi.roiMois), ML + 90, y + 3.8);
      y += 5.5;
      // Ligne eco 5/10/15 ans
      doc.setFillColor(...bg);
      doc.rect(ML, y, W - ML - MR, 5.5, 'F');
      doc.rect(ML, y, W - ML - MR, 5.5, 'S');
      doc.setTextColor(...DARK); doc.setFont('helvetica', 'normal'); doc.setFontSize(7);
      doc.text('Economies : 5 ans = ' + Math.round(sc.roi.eco5).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' | 10 ans = ' + Math.round(sc.roi.eco10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' | 15 ans = ' + Math.round(sc.roi.eco15).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' FCFA', ML + 3, y + 3.8);
      y += 5.5;
    });
    y += 3;
    const roiMin = Math.min(...roiMins);
    const roiMax = Math.max(...roiMins);
    const fmtROI2 = (mois) => { const a = Math.floor(mois/12); const m = mois%12; return a > 0 ? a + ' an' + (a>1?'s':'') + (m>0?' '+m+' mois':'') : m + ' mois'; };
    doc.setFillColor(255, 248, 225);
    doc.rect(ML, y, W - ML - MR, 8, 'F');
    doc.setDrawColor(255, 165, 0);
    doc.rect(ML, y, W - ML - MR, 8, 'S');
    doc.setTextColor(180, 90, 0); doc.setFont('helvetica', 'bold'); doc.setFontSize(8);
    doc.text('Selon votre situation, r' + String.fromCharCode(233) + 'cup' + String.fromCharCode(233) + 'rez votre investissement en ' + fmtROI2(roiMin) + ' ' + String.fromCharCode(224) + ' ' + fmtROI2(roiMax), ML + 3, y + 5.5);
    y += 10;
    y += 3;
    doc.setFillColor(232, 241, 255);
    doc.rect(ML, y, W - ML - MR, 7, 'F');
    doc.setTextColor(...BLUE); doc.setFont('helvetica', 'italic'); doc.setFontSize(7);
    doc.text('* Estimations bas' + String.fromCharCode(233) + 'es sur 6h d' + String.fromCharCode(39) + 'ensoleillement/jour. Les ' + String.fromCharCode(233) + 'conomies r' + String.fromCharCode(233) + 'elles peuvent varier selon l' + String.fromCharCode(39) + 'usage.', ML + 3, y + 4.5);
    y += 10;
  }

  if (chauffeData && !dimData && !climData) {
    const tarifKwh = 189;
    const { litres, puissW, foyer } = chauffeData;
    const montantDevis = quoteData.totalWithVat || 0;
    const consoAnnuelle = Math.round(puissW * 2.5 * 365 / 1000);
    const economiesAnnuelles = Math.round(consoAnnuelle * tarifKwh);
    const roiDecimal3 = montantDevis > 0 ? montantDevis / economiesAnnuelles : 0;
    const roiAns = roiDecimal3 > 0 ? (Math.floor(roiDecimal3) + ' an' + (Math.floor(roiDecimal3) > 1 ? 's' : '') + (Math.round((roiDecimal3 % 1) * 12) > 0 ? ' ' + Math.round((roiDecimal3 % 1) * 12) + ' mois' : '')) : '--';
    const eco10ans = economiesAnnuelles * 10;
    const eco15ans = economiesAnnuelles * 15;
    if (y + 62 > pageH - footerReserve) { doc.addPage(); y = 20; }
    y += 6;
    doc.setFillColor(...BLUE);
    doc.rect(ML, y, W - ML - MR, 7, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.text('VOTRE INVESTISSEMENT CHAUFFE-EAU SOLAIRE EN CHIFFRES', ML + 3, y + 5);
    y += 9;
    [
      ['SunXellence SUNNYBOILER ' + litres + 'L', 'Foyer : ' + foyer + ' personnes/jour', 'R' + String.fromCharCode(233) + 'sistance ' + String.fromCharCode(233) + 'lectrique ' + String.fromCharCode(233) + 'quivalente : ' + puissW + 'W'],
      ['Conso chauffe-eau ' + String.fromCharCode(233) + 'lectrique ' + String.fromCharCode(233) + 'quivalent', consoAnnuelle + ' kWh/an', 'Base : ' + puissW + 'W x 2.5h/j x 365j'],
      [String.fromCharCode(201) + 'conomies annuelles SENELEC', fmt(economiesAnnuelles) + ' FCFA/an', 'Tarif : ' + tarifKwh + ' FCFA/kWh'],
      ['Retour sur investissement', roiAns, 'Sur la base du montant NET TTC de ce devis'],
      [String.fromCharCode(201) + 'conomies sur 10 ans', fmt(eco10ans) + ' FCFA', '120 mois de facture SENELEC ' + String.fromCharCode(233) + 'conomis' + String.fromCharCode(233) + 's'],
      [String.fromCharCode(201) + 'conomies sur 15 ans', fmt(eco15ans) + ' FCFA', 'Dur' + String.fromCharCode(233) + 'e de vie garantie (15-20 ans)'],
    ].forEach(([label, value, note], idx) => {
      doc.setFillColor(...(idx % 2 === 0 ? [248, 250, 255] : [255, 255, 255]));
      doc.rect(ML, y, W - ML - MR, 6.5, 'F');
      doc.setDrawColor(...LINE);
      doc.rect(ML, y, W - ML - MR, 6.5, 'S');
      doc.setTextColor(...DARK); doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5);
      doc.text(label, ML + 3, y + 4.3);
      doc.setFont('helvetica', 'normal'); doc.setTextColor(...BLUE);
      doc.text(value, ML + 90, y + 4.3);
      doc.setTextColor(...GRAY); doc.setFontSize(6.5);
      if (note) doc.text(note, W - MR - 3, y + 4.3, { align: 'right' });
      y += 6.5;
    });
    y += 3;
    doc.setFillColor(232, 241, 255);
    doc.rect(ML, y, W - ML - MR, 7, 'F');
    doc.setTextColor(...BLUE); doc.setFont('helvetica', 'italic'); doc.setFontSize(7);
    doc.text('* SunXellence SUNNYBOILER : Énergie gratuite grâce au soleil. Estimations basées sur 2.5h/j de chauffe électrique.', ML + 3, y + 4.5);
    y += 10;
  }
  if (frigoData && !dimData && !climData && !chauffeData) {
    const tarifKwh = quoteData.tarifKwh || 189;
    const puissW = frigoData.puissW;
    const consommationAnnuelle = Math.round(puissW * 24 * 365 * 0.4 / 1000);
    const economiesAnnuelles = Math.round(consommationAnnuelle * tarifKwh);
    const montantDevis = quoteData.totalWithVat || 0;
    const roiDecimal = montantDevis > 0 ? montantDevis / economiesAnnuelles : 0;
    const roiAns = roiDecimal > 0 ? (Math.floor(roiDecimal) + ' an' + (Math.floor(roiDecimal) > 1 ? 's' : '') + (Math.round((roiDecimal % 1) * 12) > 0 ? ' ' + Math.round((roiDecimal % 1) * 12) + ' mois' : '')) : '--';
    const eco10ans = economiesAnnuelles * 10;
    const eco25ans = economiesAnnuelles * 25;
    const roiBlockH = 62;
    if (y + roiBlockH > pageH - footerReserve) { doc.addPage(); y = 20; }
    y += 6;
    doc.setFillColor(...BLUE);
    doc.rect(ML, y, W - ML - MR, 7, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.text('VOTRE INVESTISSEMENT R' + String.fromCharCode(201) + 'FRIG' + String.fromCharCode(201) + 'RATION SOLAIRE EN CHIFFRES', ML + 3, y + 5);
    y += 9;
    const roiDataFrigo = [
      ['Appareil r' + String.fromCharCode(233) + 'frig' + String.fromCharCode(233) + 'rant', frigoData.ref, 'Fonctionnement 24h/24 - cycle compresseur 40%'],
      ['Consommation ' + String.fromCharCode(233) + 'vit' + String.fromCharCode(233) + 'e', fmt(consommationAnnuelle) + ' kWh/an', 'Equivalent facture SENELEC sans solaire'],
      [String.fromCharCode(201) + 'conomies annuelles SENELEC', fmt(economiesAnnuelles) + ' FCFA/an', 'Tarif : ' + tarifKwh + ' FCFA/kWh'],
      ['Retour sur investissement', roiAns, 'Sur la base du montant NET TTC de ce devis'],
      [String.fromCharCode(201) + 'conomies sur 10 ans', fmt(eco10ans) + ' FCFA', '120 mois de facture SENELEC ' + String.fromCharCode(233) + 'conomis' + String.fromCharCode(233) + 's'],
      [String.fromCharCode(201) + 'conomies sur 25 ans', fmt(eco25ans) + ' FCFA', 'Dur' + String.fromCharCode(233) + 'e de vie minimale (30-35 ans)'],
    ];
    roiDataFrigo.forEach(([label, value, note], i) => {
      const rowBg = i % 2 === 0 ? [248, 250, 255] : [255, 255, 255];
      doc.setFillColor(...rowBg);
      doc.rect(ML, y, W - ML - MR, 6.5, 'F');
      doc.setDrawColor(...LINE);
      doc.rect(ML, y, W - ML - MR, 6.5, 'S');
      doc.setTextColor(...DARK);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7.5);
      doc.text(label, ML + 3, y + 4.3);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...BLUE);
      doc.text(value, ML + 90, y + 4.3);
      doc.setTextColor(...GRAY);
      doc.setFontSize(6.5);
      if (note) doc.text(note, W - MR - 3, y + 4.3, { align: 'right' });
      y += 6.5;
    });
    y += 3;
    doc.setFillColor(232, 241, 255);
    doc.rect(ML, y, W - ML - MR, 7, 'F');
    doc.setTextColor(...BLUE);
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(7.5);
    doc.text('Investissement rentabilis' + String.fromCharCode(233) + ' en ' + roiAns + ' — ' + fmt(eco25ans) + ' FCFA d' + String.fromCharCode(39) + String.fromCharCode(233) + 'conomies sur 25 ans', ML + 3, y + 4.8);
    y += 10;
  }


  // ── ROI + NOTE TECHNIQUE GENERATEUR ─────────────────────────────────────
  if (genData && !dimData && !climData && !chauffeData) {
    const { pointe, ref, nominal, peak, aMoteur, montantKit } = genData;
    const montantDevis = quoteData.totalWithVat || 0;
    const prixGasoil = 680;
    const consoJournaliere = pointe * 8 / 1000; // kWh/j (8h utilisation)
    const litresJour = consoJournaliere / 3.5; // 1L gasoil = 3.5 kWh
    const economiesAnnuelles = Math.round(litresJour * prixGasoil * 365);
    const roiDecimal = montantDevis > 0 && economiesAnnuelles > 0 ? montantDevis / economiesAnnuelles : 0;
    const fmtROI = (v) => { if (!v) return '--'; const a = Math.floor(v); const m = Math.round((v % 1) * 12); return a + ' an' + (a > 1 ? 's' : '') + (m > 0 ? ' ' + m + ' mois' : ''); };
    const roiAns = fmtROI(roiDecimal);
    const eco5 = economiesAnnuelles * 5;
    const eco10 = economiesAnnuelles * 10;

    if (y + 85 > pageH - footerReserve) { doc.addPage(); y = 20; }
    y += 6;

    // Header ROI
    doc.setCharSpace(0); // reset espacement caracteres
    doc.setFillColor(...BLUE);
    doc.rect(ML, y, W - ML - MR, 7, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.text('VOTRE INVESTISSEMENT G' + String.fromCharCode(201) + 'N' + String.fromCharCode(201) + 'RATEUR SOLAIRE EN CHIFFRES', ML + 3, y + 5);
    y += 9;

    [
      [ref + ' — ' + nominal + 'W nominaux | Pointe fabricant : ' + peak + 'W', 'Kit complet avec panneau(x) solaire(s)', 'Batterie LiFePO4 — 3000+ cycles'],
      ['Consommation ' + String.fromCharCode(233) + 'quivalente groupe ' + String.fromCharCode(233) + 'lectrog' + String.fromCharCode(232) + 'ne', Math.round(litresJour * 10) / 10 + ' L/j gasoil', 'Base : ' + pointe + 'W x 8h/j — 1L = 3.5 kWh'],
      [String.fromCharCode(201) + 'conomies annuelles vs groupe ' + String.fromCharCode(233) + 'lectrog' + String.fromCharCode(232) + 'ne', fmt(economiesAnnuelles) + ' FCFA/an', 'Gasoil : 680 FCFA/L'],
      ['Retour sur investissement', roiAns, 'Sur la base du montant NET TTC de ce devis'],
      [String.fromCharCode(201) + 'conomies sur 5 ans', fmt(eco5) + ' FCFA', '60 mois de carburant ' + String.fromCharCode(233) + 'conomis' + String.fromCharCode(233) + 's'],
      [String.fromCharCode(201) + 'conomies sur 10 ans', fmt(eco10) + ' FCFA', 'Dur' + String.fromCharCode(233) + 'e de vie batterie ~8-10 ans'],
    ].forEach(([label, value, note], idx) => {
      doc.setFillColor(...(idx % 2 === 0 ? [248, 250, 255] : [255, 255, 255]));
      doc.rect(ML, y, W - ML - MR, 6.5, 'F');
      doc.setDrawColor(...LINE);
      doc.rect(ML, y, W - ML - MR, 6.5, 'S');
      doc.setTextColor(...DARK); doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5);
      doc.text(label, ML + 3, y + 4.3);
      doc.setFont('helvetica', 'normal'); doc.setTextColor(...BLUE);
      doc.text(value, ML + 90, y + 4.3);
      doc.setTextColor(...GRAY); doc.setFontSize(6.5);
      if (note) doc.text(note, W - MR - 3, y + 4.3, { align: 'right' });
      y += 6.5;
    });
    y += 3;
    doc.setFillColor(232, 241, 255);
    doc.rect(ML, y, W - ML - MR, 7, 'F');
    doc.setTextColor(...BLUE); doc.setFont('helvetica', 'italic'); doc.setFontSize(7);
    doc.text('* Estimations bas' + String.fromCharCode(233) + 'es sur 8h/j d' + String.fromCharCode(39) + 'utilisation. Les ' + String.fromCharCode(233) + 'conomies r' + String.fromCharCode(233) + 'elles varient selon l' + String.fromCharCode(39) + 'usage.', ML + 3, y + 4.5);
    y += 12;

    // ── ROI SENELEC ──────────────────────────────────────────────────────────
    const tarifKwh = quoteData.tarifKwh || 200;
    const consoKwhJour = pointe * 8 / 1000;
    const ecoSenelecAnnuelle = Math.round(consoKwhJour * tarifKwh * 365);
    const roiSenelecDecimal = montantDevis > 0 && ecoSenelecAnnuelle > 0 ? montantDevis / ecoSenelecAnnuelle : 0;
    const roiSenelecAns = fmtROI(roiSenelecDecimal);
    const eco5Senelec = ecoSenelecAnnuelle * 5;
    const eco10Senelec = ecoSenelecAnnuelle * 10;

    if (y + 55 > pageH - footerReserve) { doc.addPage(); y = 20; }
    y += 4;
    doc.setCharSpace(0); // reset espacement
    doc.setFillColor(16, 185, 129);
    doc.rect(ML, y, W - ML - MR, 7, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.text('COMPARATIF VS FACTURE SENELEC', ML + 3, y + 5);
    y += 9;
    [
      ['Conso ' + String.fromCharCode(233) + 'quivalente SENELEC', Math.round(consoKwhJour * 365) + ' kWh/an', 'Base : ' + pointe + 'W x 8h/j x 365j'],
      [String.fromCharCode(201) + 'conomies annuelles vs facture SENELEC', fmt(ecoSenelecAnnuelle) + ' FCFA/an', 'Tarif : ' + tarifKwh + ' FCFA/kWh'],
      ['Retour sur investissement', roiSenelecAns, 'Sur la base du montant NET TTC de ce devis'],
      [String.fromCharCode(201) + 'conomies sur 5 ans', fmt(eco5Senelec) + ' FCFA', '60 mois de facture SENELEC ' + String.fromCharCode(233) + 'conomis' + String.fromCharCode(233) + 's'],
      [String.fromCharCode(201) + 'conomies sur 10 ans', fmt(eco10Senelec) + ' FCFA', 'Dur' + String.fromCharCode(233) + 'e de vie batterie ~8-10 ans'],
    ].forEach(([label, value, note], idx) => {
      doc.setFillColor(...(idx % 2 === 0 ? [240, 253, 244] : [255, 255, 255]));
      doc.rect(ML, y, W - ML - MR, 6.5, 'F');
      doc.setDrawColor(167, 243, 208);
      doc.rect(ML, y, W - ML - MR, 6.5, 'S');
      doc.setTextColor(...DARK); doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5);
      doc.text(label, ML + 3, y + 4.3);
      doc.setFont('helvetica', 'normal'); doc.setTextColor(5, 150, 105);
      doc.text(value, ML + 90, y + 4.3);
      doc.setTextColor(...GRAY); doc.setFontSize(6.5);
      if (note) doc.text(note, W - MR - 3, y + 4.3, { align: 'right' });
      y += 6.5;
    });
    y += 3;
    doc.setFillColor(209, 250, 229);
    doc.rect(ML, y, W - ML - MR, 7, 'F');
    doc.setTextColor(5, 150, 105); doc.setFont('helvetica', 'italic'); doc.setFontSize(7);
    doc.text('* Estimations bas' + String.fromCharCode(233) + 'es sur 8h/j d' + String.fromCharCode(39) + 'utilisation au tarif SENELEC. Les ' + String.fromCharCode(233) + 'conomies r' + String.fromCharCode(233) + 'elles varient selon l' + String.fromCharCode(39) + 'usage.', ML + 3, y + 4.5);
    y += 12;

        // ── NOTE TECHNIQUE ────────────────────────────────────────────────────
    const noteH = aMoteur ? 40 : 28;
    if (y + noteH + 4 > pageH - footerReserve) { doc.addPage(); y = 20; }
    // Fond creme premium
    doc.setFillColor(255, 251, 235);
    doc.setDrawColor(217, 119, 6);
    doc.setLineWidth(0.6);
    doc.roundedRect(ML, y, W - ML - MR, noteH, 2, 2, 'FD');
    // Bande laterale orange
    doc.setFillColor(217, 119, 6);
    doc.roundedRect(ML, y, 4, noteH, 1, 1, 'F');
    // Titre
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.setTextColor(120, 53, 15);
    doc.setCharSpace(0.8);
    doc.text('NOTE TECHNIQUE — CONDITIONS D' + String.fromCharCode(39) + 'UTILISATION', ML + 8, y + 7);
    doc.setCharSpace(0);
    // Separateur
    doc.setDrawColor(245, 158, 11);
    doc.setLineWidth(0.3);
    doc.line(ML + 8, y + 9.5, W - MR - 4, y + 9.5);
    // Corps
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(7.5);
    doc.setTextColor(92, 40, 5);
    if (aMoteur) {
      doc.text('Ce générateur est dimensionné pour une charge nominale de ' + nominal + 'W en continu.', ML + 8, y + 16);
      doc.text('Les équipements à moteur (climatiseur, frigo) génèrent des pics de démarrage', ML + 8, y + 22);
      doc.text('couverts par la puissance de pointe (' + peak + 'W).', ML + 8, y + 28);
      doc.setFont('helvetica', 'bolditalic');
      doc.setTextColor(146, 64, 14);
      doc.text('Toute utilisation continue au-delà de ' + nominal + 'W annule la garantie fabricant.', ML + 8, y + 35);
    } else {
      doc.text('Ce générateur est dimensionné pour une charge nominale de ' + nominal + 'W en continu.', ML + 8, y + 16);
      doc.setFont('helvetica', 'bolditalic');
      doc.setTextColor(146, 64, 14);
      doc.text('Toute utilisation continue au-delà de ' + nominal + 'W annule la garantie fabricant.', ML + 8, y + 23);
    }
    y += noteH + 5;
  }  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    const pH = doc.internal.pageSize.height;
    const lineY = pH - 18;
    const condY = lineY - 16;

if (i === pageCount) {
      doc.setDrawColor(...LINE);
      doc.line(M, condY, W-M, condY);
    }
    doc.setFontSize(7);
    doc.setTextColor(...DARK);
    if (i === pageCount) {
      const isATP = (items || []).some(it => it._titre && it.description && it.description.includes('AUDIT TECHNIQUE PREALABLE'));
      const footerLines = isATP ? [
        'Validit' + String.fromCharCode(233) + ' de l\u0027offre : 30 jours.',
        'Conditions de paiement : 100% apr' + String.fromCharCode(232) + 's intervention sur site (Audit Technique Pr' + String.fromCharCode(233) + 'alable).',
        'Modalit' + String.fromCharCode(233) + ' sp' + String.fromCharCode(233) + 'ciale : Le co' + String.fromCharCode(251) + 't de l\u0027ATP est int' + String.fromCharCode(233) + 'gralement rembours' + String.fromCharCode(233) + ' en cas de commande ferme.',
      ] : [
        quoteData.conditionsValidite || ('Validité de l’offre : ' + (quoteData.offerValidity||30) + ' jours;  Certifications : CE; TUV; RoHs; IP68, IP65.'),
        quoteData.conditionsPaiement || 'Conditions de paiement : 50% à la commande, solde à la livraison et mise en service.',
        quoteData.conditionsGaranties || ('Garanties : Système complet ' + (w.system||2) + ' ans; Panneaux solaires ' + (w.panels||12) + ' ans; Rendement ' + (w.performance||86.4) + '% à 30 ans; Dégradation ' + (w.degradation||0.40) + '%/an.'),
      ];
      footerLines.forEach((line, idx) => doc.text(line, M, condY + 5 + idx * 4));
    }

    doc.setFontSize(7);
    doc.setTextColor(...GRAY);
    doc.setFont('helvetica', 'normal');
    doc.text('TAKOUSSANE ENERGY  |  BP 302 Rufisque Ouest, Dakar - Senegal  |  RC: SN DKR 2016 M 1436  |  NINEA: 005711090', M, lineY + 5);
    doc.text('Page ' + i + ' / ' + pageCount, W-M, lineY + 5, { align: 'right' });
  }

  return doc;
};


// ── Précharge les URL d'images distantes en base64 (jsPDF ne supporte pas les URLs en sync) ──
const urlToBase64 = (url) => new Promise((resolve) => {
  if (!url || typeof url !== 'string') return resolve(null);
  if (url.startsWith('data:image')) return resolve(url);
  if (!url.startsWith('http')) return resolve(null);
  fetch(url)
    .then(r => r.ok ? r.blob() : null)
    .then(blob => {
      if (!blob) return resolve(null);
      const img = new Image();
      const objUrl = URL.createObjectURL(blob);
      img.onload = () => {
        const MAX = 150;
        let w = img.width, h = img.height;
        if (w > MAX || h > MAX) {
          if (w > h) { h = Math.round(h * MAX / w); w = MAX; }
          else { w = Math.round(w * MAX / h); h = MAX; }
        }
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);
        URL.revokeObjectURL(objUrl);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = () => { URL.revokeObjectURL(objUrl); resolve(null); };
      img.src = objUrl;
    })
    .catch(() => resolve(null));
});

const preloadImages = async (items) => {
  const out = [];
  for (const it of (items || [])) {
    if (it.image && typeof it.image === 'string' && it.image.startsWith('http')) {
      const b64 = await urlToBase64(it.image);
      out.push({ ...it, image: b64 || null });
    } else {
      out.push(it);
    }
  }
  return out;
};

const ConfirmationPage = () => {
  const navigate = useNavigate();
  const { user, profile } = useAuth();
  const { quoteData, updateQuoteStatus, resetQuoteData } = useQuote();
  const [downloading, setDownloading] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [showSendConfirm, setShowSendConfirm] = useState(false);
  const [emailBody, setEmailBody] = useState('');
  const [sendConfirmed, setSendConfirmed] = useState(false);
  const [error, setError] = useState(null);
  const [saveStatus, setSaveStatus] = useState('idle'); // idle | saving | saved | error
  const [showEur, setShowEur] = useState(false);
  const [tarifKwh, setTarifKwh] = useState(200);
  // Calcul a la volee pour le resume UI
  const _uiItems = (quoteData.items || []).filter(i => !i._titre);
  const _uiItemsTotal = _uiItems.reduce((s, i) => s + (parseFloat(i.unitPrice)||0) * (parseFloat(i.quantity)||0), 0);
  const _uiDelivery = parseFloat(quoteData.deliveryCost) || 0;
  const _uiDiscountPct = parseFloat(quoteData.discountPct) || 0;
  const _uiDiscountFixed = parseFloat(quoteData.discount) || 0;
  const _uiBaseRemise = _uiItemsTotal + _uiDelivery;
  const _uiDiscount = _uiDiscountPct > 0 ? Math.round(_uiBaseRemise * _uiDiscountPct / 100) : _uiDiscountFixed;
  const _uiTotalHT = _uiBaseRemise - _uiDiscount;
  const _uiVat = quoteData.vatOption !== 'without_vat' ? Math.round(_uiTotalHT * (parseFloat(quoteData.vatRate)||18) / 100) : 0;
  const _uiTotalNet = _uiTotalHT + _uiVat;
  useEffect(() => {
    supabase.from('settings').select('valeur').eq('cle', 'tarif_kwh').single()
      .then(({ data }) => { if (data) setTarifKwh(parseFloat(data.valeur) || 200); });
  }, []);
  const validateQuoteData = useCallback(() => {
    const errors = [];
    if (!quoteData.clientInfo?.clientName?.trim())
      errors.push('\u2022 Nom client manquant (\u00e9tape 1)');
    if (!quoteData.clientInfo?.email?.trim())
      errors.push('\u2022 Email client manquant (\u00e9tape 1)');
    if (!quoteData.items || quoteData.items.length === 0)
      errors.push('\u2022 Aucun article dans le devis (\u00e9tape 3)');
    if ((quoteData.subtotal || 0) === 0 && (quoteData.deliveryCost || 0) === 0 && (quoteData.discount || 0) === 0)
      errors.push('\u2022 Total est z\u00e9ro \u2014 v\u00e9rifiez les articles (\u00e9tape 3)');
(quoteData.items || []).filter(item => !item._titre).forEach((item, idx) => {
      if (!item.description?.trim())
        errors.push(`• Article ${idx + 1} : description manquante`);
      if (!item.quantity || Number(item.quantity) <= 0)
        errors.push(`• Article ${idx + 1} : quantité invalide`);
      if (!item._offert && (!item.unitPrice || Number(item.unitPrice) <= 0))
        errors.push(`• Article ${idx + 1} : prix invalide`);
    });
    return errors;
  }, [quoteData]);

  const handlePreview = useCallback(async () => {
    setError(null);
    // ✅ Fix #3 : validation avant génération PDF
    const errors = validateQuoteData();
    if (errors.length > 0) {
      setError('Impossible de générer le PDF :\n' + errors.join('\n'));
      return;
    }
    try {
      const itemsWithImages = await preloadImages(quoteData.items);
      const data = { ...quoteData, items: itemsWithImages, tarifKwh };
      window.open(URL.createObjectURL(buildPDF(data, showEur).output('blob')), '_blank');
    }
    catch (e) { setError('Erreur aperçu : ' + e.message); }
  }, [quoteData, validateQuoteData, tarifKwh, showEur]);

  const handleDownload = useCallback(async () => {
    setError(null);
    // ✅ Fix #3 : validation avant génération PDF
    const errors = validateQuoteData();
    if (errors.length > 0) {
      setError('Impossible de générer le PDF :\n' + errors.join('\n'));
      return;
    }
    setDownloading(true);
    try {
      const itemsWithImages = await preloadImages(quoteData.items);
      const data = { ...quoteData, items: itemsWithImages, tarifKwh };
      buildPDF(data, showEur).save('Devis_' + (quoteData.quoteNumber || 'SolarQuotePro') + '.pdf');
    }
    catch (e) { setError('Erreur : ' + e.message); }
    setDownloading(false);
  }, [quoteData, validateQuoteData, tarifKwh, showEur]);

const handleSendEmail = useCallback(async () => {
  setSendingEmail(true);
  setError(null);

  const toEmail = quoteData.clientInfo?.email || '';
  if (!toEmail) {
    setError('Email client manquant — vérifiez l\'étape 1');
    setSendingEmail(false);
    return;
  }

  try {
    // Générer le PDF en base64
    const itemsWithImages = await preloadImages(quoteData.items);
    const pdfDoc = buildPDF({ ...quoteData, items: itemsWithImages, tarifKwh }, showEur);
    const pdfBase64 = pdfDoc.output('datauristring').split(',')[1];

    const fromEmail = profile?.email || 'contact@takoussane.com';
    const fromName = profile?.nom || 'TAKOUSSANE ENERGY';
    const clientName = quoteData.clientInfo?.clientName || quoteData.clientInfo?.name || '';
    const subject = 'Devis ' + quoteData.quoteNumber + ' — TAKOUSSANE ENERGY';

    const defaultBody =
      'Bonjour ' + ((quoteData.clientInfo?.attentionTitle ? quoteData.clientInfo.attentionTitle + ' ' : '') + (quoteData.clientInfo?.attentionName || clientName)).trim() + ',\n\n' +
      'Veuillez trouver ci-joint votre devis No. ' + quoteData.quoteNumber + ', établi le ' + (quoteData.date ? quoteData.date.split('-').reverse().join('/') : '') + '.\n\n' +
      '--- RÉCAPITULATIF ---\n' +
      'Montant NET TTC : ' + fmt(quoteData.totalWithVat || 0) + ' FCFA\n' +
      (showEur ? '(soit ' + ((quoteData.totalWithVat || 0) / 655.957).toFixed(2) + ' EUR)\n' : '') +
      (quoteData.conditionsValidite ? quoteData.conditionsValidite.split('\n')[0].split(';')[0].trim() : ('Validité de l\'offre : ' + (quoteData.offerValidity || 30) + ' jours')) + '\n\n' +
      'Ce devis est établi sous réserve d\'acceptation dans les délais indiqués.\n' +
      'Pour toute question, n\'hésitez pas à nous contacter.\n\n' +
'Cordialement,\n\n--\n' +
fromName + '\n' +
(profile?.fonction ? profile.fonction + '\n' : '') +
'TAKOUSSANE ENERGY\n' +
'Tél : (+221) 33 836 67 83\n' +
(profile?.mobile ? 'Mob : ' + profile.mobile + '\n' : '') +
'Email : ' + fromEmail + '\n' +
'Web : https://takoussane.com';

    const body = emailBody && emailBody.trim() ? emailBody : defaultBody;

    const result = await sendQuoteEmail({
      to: toEmail,
      cc: quoteData.clientInfo?.emailsCc || [],
      from_name: fromName,
      from_email: fromEmail,
      subject,
      body,
      pdfBase64,
      quoteNumber: quoteData.quoteNumber,
    });

    if (result.success) {
      alert('✅ Email envoyé avec succès à ' + toEmail);
    } else {
      setError('Erreur envoi email : ' + result.error);
    }
  } catch (e) {
    setError('Erreur : ' + e.message);
  }

  setSendingEmail(false);
}, [quoteData, profile, emailBody, showEur, tarifKwh]);

  const handlePrint = useCallback(async () => {
    setError(null);
    try {
      const itemsWithImages = await preloadImages(quoteData.items);
      const data = { ...quoteData, items: itemsWithImages, tarifKwh };
      const blob = buildPDF(data, showEur).output('blob');
      const url = URL.createObjectURL(blob);

      const iframe = document.createElement('iframe');
      iframe.style.position = 'fixed';
      iframe.style.right = '0';
      iframe.style.bottom = '0';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = '0';
      iframe.style.visibility = 'hidden';
      iframe.src = url;

      iframe.onload = () => {
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        } catch (err) {
          setError('Erreur impression : ' + err.message);
        }
      };

      document.body.appendChild(iframe);

      setTimeout(() => {
        URL.revokeObjectURL(url);
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
      }, 60000);
    } catch (e) { setError('Erreur impression : ' + e.message); }
  }, [quoteData, tarifKwh, showEur]);

  const saveToDatabase = useCallback(async () => {
    if (!user?.id || !quoteData.quoteNumber) return;
    setSaveStatus('saving');
    setError(null);
    try {
      const rawDate = quoteData.date || '';
      const isoDate = rawDate.includes('/')
        ? rawDate.split('/').reverse().join('-')
        : rawDate;

      const payload = {
        user_id: user.id,
        quote_number: quoteData.quoteNumber,
        date: isoDate,
        statut: 'en_cours',
        client_info: quoteData.clientInfo || {},
        company_info: quoteData.companyInfo || {},
        items: quoteData.items || [],
        delivery_cost: quoteData.deliveryCost || 0,
        vat_option: quoteData.vatOption || 'with_vat',
        discount: quoteData.discount || 0,
        discount_pct: quoteData.discountPct || 0,
        conditions_validite: quoteData.conditionsValidite || '',
        conditions_paiement: quoteData.conditionsPaiement || '',
        conditions_garanties: quoteData.conditionsGaranties || '',
        subtotal: quoteData.subtotal || 0,
        vat: quoteData.vat || 0,
        total_with_vat: quoteData.totalWithVat || 0,
      };

      const { error: dbError } = await supabase
        .from('quotes')
        .upsert(payload, { onConflict: 'quote_number' });

if (dbError) throw new Error(dbError.message);

        // ── Alimentation automatique base clients ─────────────────────────
        const ci = quoteData.clientInfo || {};
        const clientNom = ci.clientName || ci.name || '';
        if (clientNom.trim()) {
          const clientPayload = {
            nom: clientNom.trim(),
            email: ci.email || null,
            mobile: ci.mobile || ci.mob || null,
            telephone: ci.phone || null,
            ville: ci.address || null,
            pays: ci.region || 'Sénégal',
            commerciale_id: user.id,
            source: 'devis',
            updated_at: new Date().toISOString(),
          };
          // Upsert sur email si disponible, sinon insert
          if (ci.email?.trim()) {
            const { data: existing } = await supabase
              .from('clients')
              .select('id')
              .eq('email', ci.email.trim())
              .eq('commerciale_id', user.id)
              .maybeSingle();
            if (existing) {
              await supabase.from('clients').update(clientPayload).eq('id', existing.id);
            } else {
              await supabase.from('clients').insert({ ...clientPayload, statut: 'prospect' });
            }
          } else {
            // Pas d'email — insert uniquement si pas déjà un client avec ce nom
            const { data: existingNom } = await supabase
              .from('clients')
              .select('id')
              .eq('nom', clientNom.trim())
              .eq('commerciale_id', user.id)
              .maybeSingle();
            if (!existingNom) {
              await supabase.from('clients').insert({ ...clientPayload, statut: 'prospect' });
            }
          }
        }
        // ─────────────────────────────────────────────────────────────────

        updateQuoteStatus('saved');
        setSaveStatus('saved');
    } catch (e) {
      setError('Erreur sauvegarde : ' + e.message);
      setSaveStatus('error');
    }
  }, [quoteData, updateQuoteStatus, user]);

  // ── Sauvegarde automatique à l'arrivée sur la page ────────────────────────
  useEffect(() => {
    if (user?.id && quoteData.quoteNumber && saveStatus === 'idle') {
      saveToDatabase();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg">
      <div className="text-center mb-8">
        <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
        <h2 className="text-3xl font-bold text-gray-800">Devis Finalisé</h2>
        <p className="text-gray-600 mt-2">Votre devis est prêt à être envoyé au client.</p>
      </div>
      {error && <Alert variant="destructive" className="mb-4"><AlertDescription>{error}</AlertDescription></Alert>}
      {saveStatus === 'saving' && (
        <div className="mb-4 p-3 bg-blue-50 border border-blue-300 text-blue-700 rounded flex items-center gap-2">
          <Loader2 className="h-4 w-4 animate-spin" /> Sauvegarde en cours...
        </div>
      )}
      {saveStatus === 'saved' && (
        <div className="mb-4 p-3 bg-green-50 border border-green-300 text-green-700 rounded flex items-center gap-2">
          ✓ Devis sauvegardé automatiquement
        </div>
      )}
      {saveStatus === 'error' && (
        <div className="mb-4 p-3 bg-red-50 border border-red-300 text-red-700 rounded flex items-center gap-2">
          ⚠️ Erreur de sauvegarde — <button onClick={saveToDatabase} className="underline font-medium">Réessayer</button>
        </div>
      )}
      <div className="bg-gray-50 p-6 rounded-lg mb-6">
        <h3 className="text-xl font-semibold mb-3">Résumé</h3>
        <div className="grid grid-cols-2 gap-3 text-sm">
          <div className="space-y-1">
            <p><span className="font-medium">N° : </span>{quoteData.quoteNumber}</p>
            <p><span className="font-medium">Date : </span>{quoteData.date ? quoteData.date.split('-').reverse().join('/') : ''}</p>
            <p><span className="font-medium">Client : </span>{quoteData.clientInfo?.clientName || quoteData.clientInfo?.name || quoteData.companyInfo?.contact || '-'}</p>
            <p><span className="font-medium">Articles : </span>{(quoteData.items || []).length}</p>
          </div>
          <div className="space-y-1">
            <p><span className="font-medium">Sous-total : </span>{fmt(_uiItemsTotal)} FCFA</p>
            {_uiDelivery > 0 && <p><span className="font-medium">Livraison : </span>{fmt(_uiDelivery)} FCFA</p>}
            {_uiDiscount > 0 && <p><span className="font-medium">Remise ({_uiDiscountPct || Math.round(_uiDiscount / _uiBaseRemise * 1000) / 10}%) : </span>- {fmt(_uiDiscount)} FCFA</p>}
            <p><span className="font-medium">TVA ({quoteData.vatRate || 0}%) : </span>{fmt(_uiVat)} FCFA</p>
            <p className="text-blue-700 font-bold text-base">NET : {fmt(_uiTotalNet)} FCFA</p>
            {showEur && <p className="text-gray-400 text-xs">≈ {(_uiTotalNet / 655.957).toFixed(2)} EUR</p>}
            <button
  onClick={() => setShowEur(v => !v)}
  className="mt-2 text-xs text-blue-500 hover:text-blue-700 underline cursor-pointer bg-transparent border-none p-0"
>
  {showEur ? 'Masquer l\'équivalent en Euros' : 'Afficher l\'équivalent en Euros'}
</button>
          </div>
        </div>
      </div>
      <div className="space-y-4 mb-4">
        {/* Actions principales */}
        <div className="flex flex-wrap justify-center gap-3">
          <button onClick={handlePreview} className="inline-flex items-center gap-2 px-6 py-3 rounded-lg text-white font-semibold bg-purple-600 hover:bg-purple-700 transition-all shadow-md hover:shadow-lg">
            <Eye className="h-5 w-5" /> Aperçu PDF
          </button>
          <button onClick={() => {
            setSendConfirmed(false);
            const cn = quoteData.clientInfo?.clientName || quoteData.clientInfo?.name || '';
            const greeting = ((quoteData.clientInfo?.attentionTitle ? quoteData.clientInfo.attentionTitle + ' ' : '') + (quoteData.clientInfo?.attentionName || cn)).trim();
            const dateStr = quoteData.date ? quoteData.date.split('-').reverse().join('/') : '';
            const validite = quoteData.conditionsValidite ? quoteData.conditionsValidite.split('\n')[0].split(';')[0].trim() : ('Validité de l\'offre : ' + (quoteData.offerValidity || 30) + ' jours');
            const fName = profile?.nom || 'TAKOUSSANE ENERGY';
            const fEmail = profile?.email || 'contact@takoussane.com';
            const corps = 'Bonjour ' + greeting + ',\n\n' +
              'Veuillez trouver ci-joint votre devis No. ' + quoteData.quoteNumber + ', établi le ' + dateStr + '.\n\n' +
              '--- RÉCAPITULATIF ---\n' +
              'Montant NET TTC : ' + fmt(quoteData.totalWithVat || 0) + ' FCFA\n' +
              (showEur ? '(soit ' + ((quoteData.totalWithVat || 0) / 655.957).toFixed(2) + ' EUR)\n' : '') +
              validite + '\n\n' +
              'Ce devis est établi sous réserve d\'acceptation dans les délais indiqués.\n' +
              'Pour toute question, n\'hésitez pas à nous contacter.\n\n' +
              'Cordialement,\n\n--\n' + fName + '\n' +
              (profile?.fonction ? profile.fonction + '\n' : '') +
              'TAKOUSSANE ENERGY\n' +
              'Tél : (+221) 33 836 67 83\n' +
              (profile?.mobile ? 'Mob : ' + profile.mobile + '\n' : '') +
              'Email : ' + fEmail + '\n' +
              'Web : https://takoussane.com';
            // Pre-remplit l'editeur avec le message par defaut UNIQUEMENT s'il est vide.
            // Si l'utilisateur a deja saisi un texte, on le conserve (jamais d'ecrasement).
            if (!emailBody || !emailBody.trim()) { setEmailBody(corps); }
            setShowSendConfirm(true);
          }} disabled={sendingEmail} className={`inline-flex items-center gap-2 px-6 py-3 rounded-lg text-white font-semibold transition-all shadow-md hover:shadow-lg ${sendingEmail ? 'bg-green-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'}`}>
            {sendingEmail ? <Loader2 className="h-5 w-5 animate-spin" /> : <Mail className="h-5 w-5" />}
            {sendingEmail ? 'Envoi...' : 'Envoyer par email'}
          </button>
      {showSendConfirm && (
        <div
          onClick={(e) => { if (e.target === e.currentTarget) setShowSendConfirm(false); }}
          style={{
            position: "fixed", inset: 0,
            background: "rgba(15, 23, 42, 0.6)",
            backdropFilter: "blur(4px)",
            WebkitBackdropFilter: "blur(4px)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 9999, padding: "16px",
            animation: "sqpFadeIn 200ms ease-out"
          }}>
          <style>{`
            @keyframes sqpFadeIn { from { opacity: 0; } to { opacity: 1; } }
            @keyframes sqpScaleIn { from { opacity: 0; transform: scale(0.96) translateY(8px); } to { opacity: 1; transform: scale(1) translateY(0); } }
          `}</style>
          <div style={{
            background: "white",
            borderRadius: "16px",
            padding: "32px",
            maxWidth: "520px", width: "100%",
            boxShadow: "0 25px 50px -12px rgba(15, 23, 42, 0.25), 0 0 0 1px rgba(15, 23, 42, 0.05)",
            animation: "sqpScaleIn 240ms cubic-bezier(0.16, 1, 0.3, 1)"
          }}>
            {/* Header */}
            <div style={{ display: "flex", alignItems: "center", gap: "14px", marginBottom: "24px" }}>
              <div style={{
                width: "44px", height: "44px",
                borderRadius: "10px",
                background: "linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)",
                display: "flex", alignItems: "center", justifyContent: "center",
                boxShadow: "0 4px 12px rgba(30, 58, 95, 0.25)"
              }}>
                <span style={{ fontSize: "22px", filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.2))" }}>⚡</span>
              </div>
              <div>
                <div style={{ fontSize: "18px", fontWeight: 700, color: "#0f172a", letterSpacing: "-0.01em" }}>Validation avant envoi</div>
                <div style={{ fontSize: "13px", color: "#64748b", marginTop: "2px" }}>Vérifiez chaque point avant de transmettre</div>
              </div>
            </div>

            {/* Checklist */}
            <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "20px" }}>
              {[
                { titre: "Articles et quantités corrects", desc: "Chaque ligne reflète le besoin du client" },
                { titre: "Prix cohérents avec le marché actuel", desc: "Tarifs à jour, marges respectées" },
                { titre: "Informations client complètes", desc: "Nom, adresse, contact, NINEA si applicable" },
                { titre: "Devis optimisé pour ce client", desc: "Configuration adaptée au besoin réel" }
              ].map((item, i) => (
                <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
                  <div style={{
                    flexShrink: 0, width: "22px", height: "22px",
                    borderRadius: "50%",
                    background: "#dcfce7",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    marginTop: "1px"
                  }}>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M2.5 6L5 8.5L9.5 4" stroke="#059669" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "14px", fontWeight: 600, color: "#0f172a", lineHeight: "1.4", textAlign: "left" }}>{item.titre}</div>
                    <div style={{ fontSize: "12.5px", color: "#64748b", marginTop: "2px", lineHeight: "1.4", textAlign: "left" }}>{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Bloc direction */}
            <div style={{
              background: "#f8fafc",
              borderLeft: "4px solid #1e3a5f",
              borderRadius: "8px",
              padding: "14px 16px",
              marginBottom: "22px",
              display: "flex", alignItems: "flex-start", gap: "12px"
            }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0, marginTop: "1px" }}>
                <path d="M12 2L4 6V12C4 16.5 7.4 20.7 12 22C16.6 20.7 20 16.5 20 12V6L12 2Z" stroke="#1e3a5f" strokeWidth="2" strokeLinejoin="round"/>
                <path d="M9 12L11 14L15 10" stroke="#1e3a5f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <div style={{ fontSize: "13px", color: "#334155", lineHeight: "1.55", textAlign: "left" }}>
                Ce devis sera envoyé immédiatement au client <strong style={{ color: "#0f172a" }}>et en copie à votre direction</strong>. Votre signature professionnelle est engagée.
              </div>
            </div>

            {/* Editeur du corps du mail */}
            <div style={{ marginBottom: "20px" }}>
              <div style={{ fontSize: "13px", fontWeight: 600, color: "#334155", marginBottom: "8px" }}>
                Message au client (modifiable)
              </div>
              <textarea
                value={emailBody}
                onChange={e => setEmailBody(e.target.value)}
                rows={7}
                style={{
                  width: "100%", boxSizing: "border-box",
                  border: "1.5px solid #e2e8f0", borderRadius: "10px",
                  padding: "12px 14px", fontSize: "13px", lineHeight: "1.5",
                  fontFamily: "inherit", color: "#334155", outline: "none",
                  resize: "vertical"
                }}
              />
            </div>


            {/* Case a cocher */}
            <label style={{
              display: "flex", alignItems: "center", gap: "12px",
              padding: "14px 16px",
              background: sendConfirmed ? "#f0fdf4" : "#f8fafc",
              border: sendConfirmed ? "1.5px solid #86efac" : "1.5px solid #e2e8f0",
              borderRadius: "10px",
              cursor: "pointer",
              marginBottom: "20px",
              transition: "all 200ms ease"
            }}>
              <input
                type="checkbox"
                checked={sendConfirmed}
                onChange={e => setSendConfirmed(e.target.checked)}
                style={{ width: "18px", height: "18px", cursor: "pointer", accentColor: "#059669", flexShrink: 0 }}
              />
              <span style={{ fontSize: "14px", fontWeight: 600, color: sendConfirmed ? "#065f46" : "#334155" }}>
                J’ai vérifié le devis et je confirme l’envoi
              </span>
            </label>

            {/* Boutons */}
            <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
              <button
                onClick={() => setShowSendConfirm(false)}
                style={{
                  padding: "11px 22px", borderRadius: "10px",
                  border: "1.5px solid #e2e8f0", background: "white",
                  color: "#475569", fontSize: "14px", fontWeight: 600,
                  cursor: "pointer", transition: "all 150ms ease"
                }}
                onMouseEnter={e => { e.currentTarget.style.background = "#f8fafc"; e.currentTarget.style.borderColor = "#cbd5e1"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "white"; e.currentTarget.style.borderColor = "#e2e8f0"; }}>
                Annuler
              </button>
              <button
                onClick={() => { setShowSendConfirm(false); handleSendEmail(); }}
                disabled={!sendConfirmed}
                style={{
                  padding: "11px 22px", borderRadius: "10px", border: "none",
                  background: sendConfirmed ? "#059669" : "#e2e8f0",
                  color: sendConfirmed ? "white" : "#64748b",
                  fontSize: "14px", fontWeight: 600,
                  cursor: sendConfirmed ? "pointer" : "not-allowed",
                  boxShadow: sendConfirmed ? "0 4px 12px rgba(5, 150, 105, 0.3)" : "none",
                  transition: "all 200ms ease",
                  display: "inline-flex", alignItems: "center", gap: "8px"
                }}
                onMouseEnter={e => { if (sendConfirmed) { e.currentTarget.style.background = "#047857"; e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = "0 6px 16px rgba(5, 150, 105, 0.4)"; } }}
                onMouseLeave={e => { if (sendConfirmed) { e.currentTarget.style.background = "#059669"; e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(5, 150, 105, 0.3)"; } }}>
                {sendConfirmed ? (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M3 8L10.5 13L18 8M5 19H19C20.1 19 21 18.1 21 17V7C21 5.9 20.1 5 19 5H5C3.9 5 3 5.9 3 7V17C3 18.1 3.9 19 5 19Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Envoyer maintenant
                  </>
                ) : (
                  <>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <rect x="5" y="11" width="14" height="10" rx="2" stroke="#64748b" strokeWidth="2"/>
                      <path d="M8 11V7C8 4.8 9.8 3 12 3C14.2 3 16 4.8 16 7V11" stroke="#64748b" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    Envoyer maintenant
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
        </div>

        {/* Actions secondaires */}
        <div className="flex flex-wrap justify-center gap-2">
          <button onClick={handleDownload} disabled={downloading} className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium border transition-colors ${downloading ? 'border-gray-300 text-gray-400 cursor-not-allowed' : 'border-blue-300 text-blue-700 hover:bg-blue-50'}`}>
            {downloading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}
            {downloading ? 'Téléchargement...' : 'Télécharger'}
          </button>
          <button onClick={handlePrint} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium border border-indigo-300 text-indigo-700 hover:bg-indigo-50 transition-colors">
            <Printer className="h-4 w-4" /> Imprimer
          </button>
          <button onClick={saveToDatabase} disabled={saveStatus === 'saving'} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors">
            <Database className="h-4 w-4" /> Mettre à jour
          </button>
        </div>
      </div>

      {/* Separateur */}
      <div className="border-t border-gray-200 my-4"></div>

      {/* Navigation */}
      <div className="flex justify-between items-center">
        <button
          type="button"
          onClick={() => navigate('/quote-form')}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium border border-blue-400 text-blue-600 hover:bg-blue-50 transition-colors"
        >
          ← Retour au devis
        </button>
        <button
          type="button"
          onClick={() => { setEmailBody(''); resetQuoteData(); navigate('/'); }}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium border border-green-400 text-green-600 hover:bg-green-50 transition-colors"
        >
          + Nouveau devis
        </button>
        <ScrollToTop />
      </div>
    </div>
  );
};

export default ConfirmationPage;
